import { parse } from "date-fns";
import format from "date-fns/format";
import ConfigsSearcher from "../config/Configs";

export const convertDate = (date) => {
  const slicedDate = date?.slice(0, 10);
  const splitedDate = slicedDate?.split("-");
  const convertedDate =
    splitedDate && `${splitedDate[2]}/${splitedDate[1]}/${splitedDate[0]}`;
  return convertedDate;
};

export const parseDate = (date) => {
  const slicedDate = date?.slice(0, 10);
  const splitedDate = slicedDate?.split("-");
  const convertedDate =
    splitedDate && `${splitedDate[0]}-${splitedDate[1]}-${splitedDate[2]}`;
  return convertedDate;
};

export const dateFormats = () => {
  const config = ConfigsSearcher();
  const locale = config.configFinder("DATE_FORMAT");
  const localeTime = config.configFinder("DATETIME_FORMAT");
  const localeCountry = config.configFinder("LOCALE");

  const formatLocalDate = (value, formatDate) => {
    if (value !== null && value !== "" && value !== "-") {
      try {
        const dt = parse(value, formatDate, new Date());
        const dtDateOnly = new Date(
          dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
        );
        const formattedDate = format(dtDateOnly, locale);
        return formattedDate;
      } catch (err) {
        return "-";
      }
    }
    return "-";
  };

  const formatLocalDateTime = (value, formatDate, formatTime) => {
    try {
      const timeDate = value.split("T");
      console.log("TimeDate", timeDate);

      if (timeDate.length > 1) {
        console.log("tiemdata", timeDate);
        const date = parse(timeDate[0], formatDate, new Date());
        const time = parse(timeDate[1], formatTime, new Date());
        const formattedDate = format(date, locale);
        const formattedTime = format(time, localeTime);
        const returnDate = formattedDate + " " + formattedTime.split(" ")[1];
        return returnDate;
      } else {
        const timeDate = value.split(" ");
        if (timeDate.length > 1) {
          const date = parse(timeDate[0], formatDate, new Date());
          const time = parse(timeDate[1], formatTime, new Date());
          const formattedDate = format(date, locale);
          const formattedTime = format(time, localeTime);
          const returnDate = `${formattedDate} ${formattedTime.split(" ")[1]}`;
          return returnDate;
        } else {
          return "-";
        }
      }
    } catch (err) {
      return "-";
    }
  };

  const formatDate = (date) => {
    if (date) {
      let newDate = new Date(date);
      return newDate.toLocaleDateString(localeCountry || "es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  };

  /**
   * Formatea fecha+hora en zona Argentina (pedidos de agencias, etc.).
   * Usa LOCALE de config y timeZone fija America/Argentina/Buenos_Aires.
   * Acepta strings ISO 8601 con offset (ej. "2024-01-26T18:30:45-03:00").
   */
  const formatDateTimeArgentina = (dateString) => {
    if (dateString == null || dateString === "") return "-";
    try {
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return "-";
      const locale = localeCountry || "es-AR";
      return date.toLocaleString(locale, {
        timeZone: "America/Argentina/Buenos_Aires",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (err) {
      return "-";
    }
  };

  return {
    formatLocalDate,
    formatLocalDateTime,
    formatDate,
    formatDateTimeArgentina,
  };
};

export const formatDateJava = (date) => {
  let newDate = new Date(date);
  return newDate
    .toLocaleDateString("ja-JP", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-");
};
